import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, RadioGroup, FormControlLabel, Radio, Alert, CircularProgress } from '@mui/material';
import { dictionaryService } from '../services/api';

function SuggestWordForm({ defaultWord = '' }) {
  const [word, setWord] = useState(defaultWord);
  const [language, setLanguage] = useState('duala');
  const [note, setNote] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setWord(defaultWord);
    setDone(false);
  }, [defaultWord]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!word.trim()) return;
    setSubmitting(true);
    setError('');
    dictionaryService.suggestWord({ word: word.trim(), language, note: note.trim(), contact_email: contactEmail.trim() })
      .then(() => setDone(true))
      .catch(() => setError("Erreur lors de l'envoi de la suggestion, réessayez plus tard."))
      .finally(() => setSubmitting(false));
  };

  if (done) {
    return <Alert severity="success" sx={{ mt: 2 }}>Merci ! Votre suggestion a bien été transmise.</Alert>;
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        Ce mot n'existe pas encore dans le dictionnaire ? Suggérez-le :
      </Typography>
      <TextField
        fullWidth
        size="small"
        label="Mot"
        value={word}
        onChange={(e) => setWord(e.target.value)}
        required
        sx={{ mb: 1 }}
      />
      <RadioGroup row value={language} onChange={(e) => setLanguage(e.target.value)} sx={{ mb: 1 }}>
        <FormControlLabel value="duala" control={<Radio size="small" />} label="C'est un mot en douala" />
        <FormControlLabel value="francais" control={<Radio size="small" />} label="C'est un mot en français" />
      </RadioGroup>
      <TextField
        fullWidth
        size="small"
        label="Précision (traduction, contexte...)"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        multiline
        minRows={2}
        sx={{ mb: 1 }}
      />
      <TextField
        fullWidth
        size="small"
        label="Votre email (optionnel, si vous voulez être recontacté)"
        type="email"
        value={contactEmail}
        onChange={(e) => setContactEmail(e.target.value)}
        sx={{ mb: 1 }}
      />
      {error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
      <Button type="submit" variant="contained" disabled={submitting || !word.trim()} startIcon={submitting ? <CircularProgress size={16} /> : null}>
        Envoyer la suggestion
      </Button>
    </Box>
  );
}

export default SuggestWordForm;
